import { useCallback } from 'react';

import { OptionsObject, SnackbarMessage, useSnackbar as useNotistackSnackbar } from 'notistack';

import useUploadedFilesStore from '@/shared/api/uploadedFiles';
import { CustomSnackbarContent, SnackbarVariant } from '@/shared/ui/CustomSnackbar';

const MS_PER_WORD = 400;
const MIN_DURATION = 4000;
const MAX_DURATION = 10000;

const getAutoHideDuration = (message: SnackbarMessage): number => {
  const text = typeof message === 'string' ? message : '';
  const wordCount = text.split(/\s+/).filter(Boolean).length;
  return Math.min(MAX_DURATION, Math.max(MIN_DURATION, wordCount * MS_PER_WORD));
};

export function useSnackbar() {
  const { enqueueSnackbar: notistackEnqueue, closeSnackbar } = useNotistackSnackbar();

  const enqueueSnackbar = useCallback(
    (message: SnackbarMessage, options?: OptionsObject) => {
      const variant = (options?.variant || 'default') as SnackbarVariant;

      if (
        variant === 'success' &&
        (options as any)?.isUploadFeedback &&
        useUploadedFilesStore.getState().files.length > 0
      ) {
        return null as any;
      }

      const autoHideDuration = options?.autoHideDuration ?? getAutoHideDuration(message);

      return notistackEnqueue(message, {
        ...options,
        autoHideDuration,
        content: (key) => (
          <CustomSnackbarContent
            id={key}
            message={message}
            variant={variant}
            autoHideDuration={autoHideDuration}
          />
        ),
      });
    },
    [notistackEnqueue],
  );

  return { enqueueSnackbar, closeSnackbar };
}
